import { FeatureFlag } from "../../feature-flags";
import {
  useOnboardingFeatureEnabled,
  type OnboardingFeatureEnabledResult,
} from "../../onboarding/hooks/useOnboardingFeatureEnabled";

/**
 * Composite gate for Pay Component Import.
 *
 * Requires both `enable-onboarding` and `enable-pay-component-import`.
 */
export function usePayComponentImportEnabled(): OnboardingFeatureEnabledResult {
  return useOnboardingFeatureEnabled(FeatureFlag.EnablePayComponentImport);
}
